module.exports = __webpack_public_path__ + "static/8-d2c10d2ff756d1b27af1d35feba6be80.jpg";